import {AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {Vehicle, VehicleSettings, VehicleTrackerStateIcon} from 'shared';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Component({
  selector: 'app-vehicles-tracker-state-icon',
  templateUrl: './vehicles-tracker-state-icon.component.html',
  styleUrls: ['./vehicles-tracker-state-icon.component.scss']
})
export class VehiclesTrackerStateIconComponent implements OnInit, AfterViewInit {

  @ViewChild('iconBtn') iconBtn: ElementRef;

  @Input()
  settings: VehicleSettings;

  get stateIcon(): VehicleTrackerStateIcon {
    return this._stateIcon;
  }

  @Input()
  set stateIcon(value: VehicleTrackerStateIcon) {
    this._stateIcon = value;
    this.iconUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(this._stateIcon.icon);
  }

  _stateIcon: VehicleTrackerStateIcon;

  iconUrl: SafeResourceUrl;

  constructor(private domSanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
  }

  changeIconImg(e: any) {
    (this.iconBtn.nativeElement as HTMLElement).click();
  }

  onIconUpload(e: any) {
    const file = e.target.files[0];
    const reader = new FileReader();
    // this.loadingChange.emit(true);
    reader.onload = (event) => {
      // this.valueChange.emit(dataUrl);
      // this.profilePhoto.nativeElement.src = dataUrl;

      // this.loadingChange.emit(false);
      this.iconUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(reader.result as string);
      this._stateIcon.icon = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  ngAfterViewInit(): void {
  }
}
